import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Check, Package, ArrowRight, Home, MapPin } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useCart } from '../context/CartContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CheckoutSuccessPage() {
    const [searchParams] = useSearchParams();
    const { fetchCart } = useCart();
    const orderId = searchParams.get('order_id');
    const [order, setOrder] = useState(null);

    useEffect(() => {
        // Refresh cart to clear it
        fetchCart();
    }, [fetchCart]);

    useEffect(() => {
        if (!orderId) return;
        axios.get(`${API}/orders/${orderId}`, { withCredentials: true })
            .then(res => setOrder(res.data))
            .catch(() => {});
    }, [orderId]);

    const di = order?.delivery_info || {};
    const isPickup = order?.delivery_type === 'pickup';

    return (
        <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-4">
            <div className="text-center max-w-md" data-testid="checkout-success">
                <div className="w-24 h-24 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6 animate-fadeIn">
                    <Check className="w-12 h-12 text-green-600" />
                </div>
                <h1 className="text-3xl font-bold text-slate-900 mb-2 animate-fadeIn delay-100">
                    Order Submitted!
                </h1>
                <p className="text-lg text-slate-600 mb-8 animate-fadeIn delay-200">
                    Thank you for your order. We'll have your fresh produce ready soon.
                </p>

                <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-100 mb-6 animate-fadeIn delay-300">
                    <div className="flex items-center justify-center gap-3 text-[#1B4D3E] mb-4">
                        <Package className="w-6 h-6" />
                        <span className="font-semibold">Order Details</span>
                    </div>
                    <div className="text-slate-600 space-y-2">
                        {orderId && (
                            <p className="text-sm">
                                Order ID: <span className="font-mono font-medium">{orderId.slice(-8)}</span>
                            </p>
                        )}
                        {isPickup ? (
                            <p data-testid="success-schedule">
                                Pickup on <span className="font-semibold text-slate-900">{di.fulfil_label || 'Saturday'}</span>
                                {di.window_label ? ` (${di.window_label})` : ''} at {di.pickup_location?.name || 'Orange Grove Market'}
                            </p>
                        ) : (
                            <p data-testid="success-schedule">
                                Delivery on <span className="font-semibold text-slate-900">{di.fulfil_label || 'Tuesday'}</span>
                                {di.time_slot_label ? ` · ${di.time_slot_label}` : ''}
                            </p>
                        )}
                        {(di.cutoff_label) && (
                            <p className="text-xs text-slate-500">Order cut-off: {di.cutoff_label} (Sydney time)</p>
                        )}
                        <p className="text-sm text-slate-500">
                            Payment: Cash/EFTPOS on delivery or bank transfer
                        </p>
                    </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fadeIn delay-400">
                    <Link to="/dashboard">
                        <Button className="btn-secondary w-full sm:w-auto">
                            View Orders
                            <ArrowRight className="w-4 h-4 ml-2" />
                        </Button>
                    </Link>
                    <Link to="/">
                        <Button variant="outline" className="w-full sm:w-auto">
                            <Home className="w-4 h-4 mr-2" />
                            Back to Home
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
}
